<template>
  <div :class="isRoot ? 'menu-container' : 'menu-item'">
    <template v-if="isRoot">
      <scrollbar type="none">
        <el-menu
          ref="menu"
          v-bind="$attrs"
          slot="scrollbar"
          :default-active="defaultActive"
          :default-openeds="defaultOpeneds"
          mode="vertical"
          @select="handleSelect"
          @open="handleOpen"
          @itemContextmenu="handleContextmenuRoot"
        >
          <template v-for="item in menu">
            <MenuItem :is-root="false" :item="item" :key="item[config.id]" />
          </template>
        </el-menu>
      </scrollbar>
    </template>
    <template v-else>
      <template v-if="hasChildren">
        <el-submenu :index="id">
          <span slot="title">{{ title }}</span>
          <template v-for="item in children">
            <MenuItem :is-root="false" :item="item" :key="item.id" />
          </template>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item
          :index="id"
          ref="menuItem"
          @contextmenu.native.stop.prevent="handleContextmenu"
        >
          <span>{{ title }}</span>
          <StatusIcon class="right-icon" :data="item" />
        </el-menu-item>
      </template>
    </template>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';
import StatusIcon from '../StatusIcon';
import { isOffice } from '@/utils/deviceUtils';

export default {
  name: 'MenuItem',
  components: { StatusIcon },
  props: {
    defaultActive: {
      type: String,
      default: ''
    },
    defaultOpeneds: {
      type: Array,
      default: () => []
    },
    menu: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({
        title: 'name',
        children: 'children',
        id: 'id'
      })
    },
    isRoot: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      root: null
    };
  },
  computed: {
    id() {
      return this.item[this.config.id];
    },
    title() {
      return this.item[this.config.title];
    },
    children() {
      return this.item[this.config.children];
    },
    hasChildren() {
      return isOffice(this.item.nodeType);
    }
  },
  methods: {
    open(id) {
      if (!isEmpty(this.$refs.menu)) return;
      this.$refs.menu.open(id);
    },
    handleSelect(e) {
      this.$emit('select', e);
      this.$emit('node-click', e);
    },
    handleOpen(e) {
      this.$emit('open', e);
      this.$emit('node-click', e);
    },
    handleContextmenuRoot(e) {
      this.$emit('itemContextmenu', e);
    },
    handleContextmenu(e) {
      this.$refs.menuItem.rootMenu.$emit('itemContextmenu', {
        event: e,
        data: this.item,
        config: this.config
      });
    }
  }
};
</script>

<style lang="scss">
.menu-container {
  width: 100%;
  height: 100%;

  .el-menu {
    border-right: unset;

    .el-menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      position: relative;

      .right-icon {
        position: absolute;
        right: 15px;
      }
    }
  }
}
</style>
